<template>
  <div class="page-content menu">
    <div class="center-text own-title main-title mb-10">GEN - GROW</div>
    <div class="content bottom-0">
      <div class="link-list link-list-1 link-list-icon-bg bottom-40 text-left">
        <router-link :to="{ path: 'about-generali' }">
            <i class="fa fa-book-new-menu round-large"></i>
            <span>About Generali</span>
        </router-link>   
        <router-link :to="{ path: 'life-insurance-opportunity' }">
            <i class="fa fa-insurance round-large"></i>
            <span>Life Insurance Opportunity</span>
        </router-link>   
        <router-link :to="{ path: 'perks' }">
            <i class="fa fa-perks-menu round-large"></i>
            <span>My Potential Income</span>
        </router-link>   
        <router-link :to="{ path: 'explore-the-world' }">
            <i class="fa fa-globe-africa round-large"></i>
            <span>Explore The World</span>
        </router-link>   
        <router-link :to="{ path: 'awards' }">
            <i class="fa fa-awards round-large"></i>
            <span>Awards & Recognition</span>
        </router-link>   
        <router-link :to="{ path: 'success-roadmap' }">
            <i class="fa fa-roads round-large"></i>
            <span>My Success Roadmap</span>
        </router-link>   
        <router-link :to="{ path: 'bussiness-opportunity-support-scheme' }">
            <i class="fa fa-boss round-large"></i>
            <span>BOSS</span>
        </router-link>   
        <router-link :to="{ path: 'talent-profiling-guide' }">
            <i class="fa fa-talent round-large"></i>
            <span>My Talent Profiling Guide</span>
        </router-link>   
        <router-link :to="{ path: 'career-lifestyle-survey' }">
            <i class="fa fa-career round-large"></i>
            <span>Career & Lifestyle Survey Guide</span>
        </router-link>  

      </div> 
      <div class="logo-affin text-center">
        <!-- <img src="images/mpower/affin-logo.png"> -->
        <img src="images/mpower-new/logo-icon/Logo-Red.png">
      </div> 
    </div>
  </div>
</template>

<style scoped>
.link-list i{
  border-radius:100%;
  border: 1px solid #AC1F08;
  color:#AC1F08;
  margin-left: 30px;
}

.link-list-1.link-list-icon-bg span {
    padding-left: 40px;
}
.color-perk{
  background-color: #2d348a;
}
.color-insurance{
  background-color: #ec9eb4;
}
.color-explore{
  background-color: #f5cd7f;
}
.color-awards{
  background-color: #e6e78d;
}
.color-road{
  background-color: #9ccead;
}
.color-eye{
  background-color: #aec9e6;
}
.color-talent{
  background-color: #067181;
}
.logo-affin{
  margin: 0 auto;
  padding-top: 8%;
}
.logo-affin img{
  min-width: 150px;
  max-width: 20%;
}
</style>

<script>

export default {
  name: 'Menu',
  components: {
  }, 
  mounted(){
      document.querySelector(".header-s").style.display = "block";
      document.querySelector(".header").style.zIndex = "96";
  },
}
</script>
